export default __webpack_public_path__ + "static/media/PS_outline.a7b7cf84.png";